
/**
 * Classe resposável em manter as autorizações do usuário.
 */
export class PermissoesDTO {

    aplicat: string;
    form: string;
    child: string;
    papel: string;
    path: string;

    constructor() { }
}